import type { Topic } from '../types/content';

export const topics: Topic[] = [
  {
    id: 'topic-001',
    title: '2026 秋季新番推荐',
    desc: '本季最值得追的新番一览，从治愈到热血一网打尽。',
    cover: 'https://readdy.ai/api/search-image?query=autumn%20anime%20season%20illustration%20with%20maple%20leaves%20and%20glowing%20screens%20showing%20colorful%20scenes%2C%20fresh%20green%20and%20orange%20tones%2C%20clean%20flat%20editorial%20style%2C%20wide%20landscape%20composition&width=800&height=520&seq=topic-cover-001&orientation=landscape',
    count: 42,
    tag: '新番',
  },
  {
    id: 'topic-002',
    title: '经典作品回顾',
    desc: '那些年被反复回味的高分神作，值得再读一遍。',
    cover: 'https://readdy.ai/api/search-image?query=classic%20manga%20collection%20illustration%20with%20vintage%20volumes%20and%20soft%20warm%20light%2C%20nostalgic%20green%20and%20amber%20palette%2C%20elegant%20flat%20editorial%20style%2C%20wide%20landscape%20composition&width=800&height=520&seq=topic-cover-002&orientation=landscape',
    count: 28,
    tag: '经典',
  },
  {
    id: 'topic-003',
    title: '国漫崛起特辑',
    desc: '从画风到叙事，国漫正在被更多人看见。',
    cover: 'https://readdy.ai/api/search-image?query=modern%20chinese%20webcomic%20illustration%20with%20bold%20ink%20and%20green%20highlights%2C%20rising%20chart%20motif%2C%20dynamic%20flat%20editorial%20style%2C%20wide%20landscape%20composition&width=800&height=520&seq=topic-cover-003&orientation=landscape',
    count: 35,
    tag: '国漫',
  },
  {
    id: 'topic-004',
    title: '治愈系深夜食堂',
    desc: '一碗热汤，一段故事，陪你度过安静的夜。',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20midnight%20food%20stall%20illustration%20with%20steaming%20bowls%20and%20warm%20lanterns%2C%20gentle%20green%20and%20amber%20palette%2C%20soft%20flat%20editorial%20style%2C%20wide%20landscape%20composition&width=800&height=520&seq=topic-cover-004&orientation=landscape',
    count: 21,
    tag: '治愈',
  },
];